// Strings for the read-only Relationships tab, copied from client.ClientDetail.Relationships.
export default {
  Title: 'Relationships',
  Details: {
    Name: 'Name',
    ConnectionType: 'Connection relationship',
    Priority: 'Priority',
    Description: 'Description',
    NoDescription: 'No description entered',
  },
  Contacts: {
    Title: 'Contact Methods',
    NoneAdded: 'None added',
    Email: 'Email',
    Phone: 'Phone',
  },
};
